import { Loader } from './styles'
import logo from '../../assets/logo.png'

const Component = () => {
  return (
    <Loader>
      <img src={logo} alt='GASAPP' width='183' />
    </Loader>
  )
}

export default Component
